import { render, staticRenderFns } from "./stepDocumentFields.vue?vue&type=template&id=77720fb1&scoped=true&"
import script from "./stepDocumentFields.vue?vue&type=script&lang=js&"
export * from "./stepDocumentFields.vue?vue&type=script&lang=js&"
import style0 from "./stepDocumentFields.vue?vue&type=style&index=0&id=77720fb1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77720fb1",
  null
  
)

export default component.exports